import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import PasswordForm from './change-password-form';
import DeleteAccount from './delete-account-form';
import LoadingReactor from '../../components/loading-reactor/loading-reactor';
import './user-profile.css'


class UserProfile extends Component {
    constructor(props){
        super(props);
        this.state = {}
    }

    render() { 
        if(this.props.userDataLoading || this.props.bargainsLoading){
            return (
                <div className="container d-flex align-items-center justify-content-center loading-container fade-in-fwd">
                    <LoadingReactor />
                </div>
            )
        } else {
            if(this.props.userLoggedIn){
                return ( 
                    <div className="container profile-container">
    
                        <div className="row d-flex align-items-center justify-content-center pb-5 pt-5">
                            <div className="col-12">
                                <h1 className="text-white">{this.props.userData.userName}</h1>
                            </div>
                            <div className="col-12">
                                <h2 className="text-secondary">{this.props.userData.email}</h2>
                            </div>
                            <div className="col-12">
                                <h6 className="text-warning">*Remember to keep your card updated or your account may become lost.</h6>
                            </div>
                        </div>
    
                        <div className="row pt-1 pb-5">
                            <div className="col-12">
                                <h3 className="text-white p-2">Favorites:</h3>
                            </div>
                            {this.props.userData.favorites.length === 0
                            ? <div className="col-12 border-top border-dark">
                                <h3 className="text-secondary text-center p-3">(Favorites will appear here)</h3>
                            </div>
                            :<div className="col-12 border-top border-dark">
                                {this.props.bargains.filter(bargain => this.props.userData.favorites.includes(bargain._id)).sort((a, b) => new Date(b.date) - new Date(a.date)).map((bargain, key) => {
                                    if(bargain.companySummary && bargain.companySummary.MarketCapitalization){
                                        const bargainPercentage = ((bargain.companySummary.MarketCapitalization / bargain.ncav) * 100).toFixed(2);
                                        return (
                                            <Link to={{pathname: `/bargain/${bargain.symbol}`}} className="text-decoration-none p-0" key={key}>
                                                <div className="container border-bottom border-dark py-1">
                                                    <div className="row py-3">
                                                        <div className="col-12 col-md-2">
                                                            <h5 className="text-secondary">{bargain.symbol}</h5>
                                                        </div>
                                                        <div className="col-12 col-md-3">
                                                            {bargain.cashAssetValue > 0 ? <h5 className="text-success text-truncate">{bargain.companySummary.Name}</h5> : <h5 className="text-white text-truncate">{bargain.companySummary.Name}</h5>}
                                                        </div>
                                                        <div className="col-12 col-md-2">
                                                            {(bargainPercentage < 70.0 && bargainPercentage > 0) ? <h5 className="text-success fw-bold">{bargainPercentage}%</h5> : <h5 className="text-white fw-bold">{bargainPercentage}%</h5>}
                                                        </div>
                                                        <div className="col-12 col-md-2">
                                                            <h5 className="text-secondary">{bargain.companySummary.Exchange}</h5>
                                                        </div>
                                                        <div className="col-12 col-md-2">
                                                            <h5 className="text-secondary">{bargain.companySummary.Country}</h5>
                                                        </div>
                                                        {this.props.userData.favorites.includes(bargain._id)
                                                        ?<div className="col-12 col-md-1 text-success">√</div>
                                                        : <div className="col-12 col-md-1"></div>}
                                                    </div>
                                                </div>
                                            </Link>
                                        )

                                    } else {
                                        return (
                                            <></>
                                        )
                                    }
                                })}
                            </div>
                            }
                        </div>
                        <PasswordForm/>
                        <div className="col-12 text-center py-4">
                            <a href='https://billing.stripe.com/p/login/6oU5kC9lp1Si6TA21s5ZC00' target="_blank" rel="noopener noreferrer">
                                <button type="button" className="btn btn-outline-dark btn-lg w-100">
                                    <h3 className="text-white display-6 fs-2 py-1">Manage Subscription / Update Payment</h3>
                                </button>
                            </a>
                        </div>
                        <DeleteAccount/>
                    </div>
                 );
            } else {
                return (
                    <div className="container fade-in-fwd my-container-1 d-flex align-items-center justify-content-center">
                        <div className="row p-5">
                            <div className="col-12">
                                <h1 className="text-white">You must be logged in to view the profile page.</h1>
                            </div>
                        </div>
                    </div>
                )
            }
        }
        
    }
}

const mapStateToProps = state => {
    return {
        userLoggedIn: state.userState.userLoggedIn,
        userData: state.userData.userData,
        userDataLoading: state.userData.userDataLoading,
        bargains: state.bargainState.bargains,
        bargainsLoading: state.bargainState.bargainsLoading
    }
}

export default connect(mapStateToProps)(UserProfile);